document.addEventListener('DOMContentLoaded', function documentLoad() {
	function loadMorePosts(platformValue, serviceValue, industryValue) {
		const platformId = platformValue;
		const industryId = industryValue;
		const serviceId = serviceValue;
		document.getElementById('loadmore-button-truestory').style.display = 'none';
		document.getElementById('loadmore-loader-truestory').style.display = 'initial';
		const page = document.getElementById('pagination-page-truestory').value;
		const offset = document.getElementById('pagination-offset-truestory').value;
		const postType = document.getElementById('post_type-truestory').value;
		const excludedId = document.getElementById('excluded_id').value;
		const maxPages = document.getElementById('max-page-truestory').value;
		let orderBy = '';
		if (document.getElementById('order_by_truestory')) {
			orderBy = document.getElementById('order_by_truestory').value;
		}
		const xhr = new XMLHttpRequest();
		xhr.open('POST', ajaxload_params.ajaxurl); //eslint-disable-line
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		xhr.onload = function () {
			if (xhr.status === 200) {
				const response = JSON.parse(xhr.responseText);
				if (response) {
					document.getElementById('loadmore-button-truestory').style.display = 'initial';
					document.getElementById('loadmore-loader-truestory').style.display = 'none';
					document.getElementById('insertajax').insertAdjacentHTML('beforeend', response.html);
					document.getElementById('pagination-page-truestory').value = response.page;
					document.getElementById('pagination-offset-truestory').value = response.offset;
					const element = document.getElementById('categories');
					element.classList.add('category-mt');
					document.getElementById('categories').style.display = 'block';
					if (
						response.platformId !== '' ||
						response.serviceId !== '' ||
						response.industryId !== ''
					) {
						document.getElementById('animated-hide').style.display = 'none';
						if (response.platformQty > 10) {
							const maxPagePlatform = Math.round(response.platformCount + 1); //eslint-disable-line
							if (parseInt(page, 0) + 1 === parseInt(maxPagePlatform, 0)) {
								document.getElementById('loadmore-button-truestory').style.display = 'none';
								document.getElementById('loadmore-loader-truestory').style.display = 'none';
							}
						} else {
							document.getElementById('loadmore-button-truestory').style.display = 'none';
							document.getElementById('loadmore-loader-truestory').style.display = 'none';
						}
					} else {
						const elementFilter = document.getElementById('categories');
						elementFilter.classList.remove('category-mt');
						document.getElementById('categories').style.display = 'none';
						document.getElementById('animated-hide').style.display = 'block';
					}
					if (parseInt(page, 0) + 1 === parseInt(maxPages, 0)) {
						document.getElementById('loadmore-button-truestory').style.display = 'none';
						document.getElementById('loadmore-loader-truestory').style.display = 'none';
					}
				}
				if (response === 0) {
					document.getElementById('loadmore-loader-truestory').style.display = 'none';
				}
			}
		};
		const ajaxNonce = ajaxload_params.nonce; //eslint-disable-line
		xhr.send(
			`action=load_more_truestory&page=${page}&offset=${offset}&post_type=${postType}&order_by=${orderBy}&posts_per_page=10&nonce${ajaxNonce}&industryId=${industryId}&serviceId=${serviceId}&platformId=${platformId}&excluded_id=${excludedId}`,
		);
	}

	const selectedPlatforms = [];
	const selectedServices = [];
	const selectedIndustries = [];

	function updateSelectedValues(filter, selectedValuesArray) {
		selectedValuesArray.length = 0; //eslint-disable-line
		filter.forEach(box => {
			if (box.checked) {
				selectedValuesArray.push({ id: box.value, name: box.getAttribute('data-category') });
			}
		});
	}
	function applyFilters() {
		document.getElementById('excluded_id').value = '';
		updateSelectedValues(
			document.querySelectorAll('input[type="checkbox"][name="platform[]"]'),
			selectedPlatforms,
		);
		updateSelectedValues(
			document.querySelectorAll('input[type="checkbox"][name="service[]"]'),
			selectedServices,
		);
		updateSelectedValues(
			document.querySelectorAll('input[type="checkbox"][name="industry[]"]'),
			selectedIndustries,
		);

		const platformValues = selectedPlatforms
			.map(
				platform =>
					`<span class="filter-category" id="remove-${platform.id}">${platform.name} <label for="${platform.id}" data-ids="${platform.id}"  class="hide-filter"><input checked type="checkbox" name="platform1[]" data-platform="${platform.name}" value="${platform.id}" id="${platform.id}"><img decoding="async" src="https://infobeans.ai/wp-content/uploads/2024/05/truestorycross.png" alt="cross-black"></label></span>`,
			)
			.join('');
		const serviceValues = selectedServices
			.map(
				service =>
					`<span class="filter-category" id="remove-${service.id}">${service.name} <label for="${service.id}" data-ids="${service.id}"   class="hide-filter"><input type="checkbox" checked name="service1[]" data-service="${service.name}" value="${service.id}" id="${service.id}"><img decoding="async" src="https://infobeans.ai/wp-content/uploads/2024/05/truestorycross.png" alt="cross-black"></label></span>`,
			)
			.join('');
		const industryValues = selectedIndustries
			.map(
				industry =>
					`<span class="filter-category" id="remove-${industry.id}">${industry.name} <label for="${industry.id}" data-ids="${industry.id}"  class="hide-filter"><input type="checkbox" checked name="industry1[]" data-industry="${industry.name}" value="${industry.id}" id="${industry.id}"><img decoding="async" src="https://infobeans.ai/wp-content/uploads/2024/05/truestorycross.png" alt="cross-black"></label></span>`,
			)
			.join('');
		const clear = `<button class="filter-clear" type="button" id="filter-clear">Clear</button>`;
		document.getElementById('categories').innerHTML = // phpcs:ignore.
		platformValues + serviceValues + industryValues + clear;//eslint-disable-line

		const platformValue = selectedPlatforms.map(platform => platform.id).join(',');
		const serviceValue = selectedServices.map(service => service.id).join(',');
		const industryValue = selectedIndustries.map(industry => industry.id).join(',');

		document.getElementById('trueStory').innerHTML = '';
		document.getElementById('insertajax').innerHTML = '';

		document.getElementById('platformid').value = platformValue;
		document.getElementById('serviceid').value = serviceValue;
		document.getElementById('industryid').value = industryValue;

		document.getElementById('pagination-page-truestory').value = '1';
		document.getElementById('max-page-truestory').value = '1';
		document.getElementById('pagination-offset-truestory').value = '0';
		loadMorePosts(platformValue, serviceValue, industryValue);

		const clearButton = document.getElementById('filter-clear');
		if (clearButton) {
			clearButton.addEventListener('click', function () {
				const checkboxes = document.querySelectorAll('input[type="checkbox"]');
				checkboxes.forEach(function (checkbox) {
					checkbox.checked = false; //eslint-disable-line
				});
				refreshSection('categories'); //eslint-disable-line
				document.getElementById('platformid').value = '';
				document.getElementById('serviceid').value = '';
				document.getElementById('industryid').value = '';
			});
		}
		applyFilter();//eslint-disable-line
	}

	function applyFilter() {
		const allRemoves = document.querySelectorAll('.hide-filter');
		allRemoves.forEach(allRemove => {
			allRemove.addEventListener('click', function () {
				const dataValue = allRemove.dataset.ids;
				if (dataValue) {
					const ids = dataValue.split(',');
					const inputs = document.querySelectorAll('.filterchecked');
					const platformDivToRemove = document.getElementById(`remove-${dataValue}`);
					for (let i = 0; i < inputs.length; i++) {//eslint-disable-line
						const checkbox = inputs[i];
						if (ids.indexOf(checkbox.value) !== -1) {
							// Check if checkbox value matches an ID
							checkbox.checked = false;
							platformDivToRemove.remove();
							applyFilters();
						}
					}
				}
			});
		});
	}

	// Function to refresh a section
	function refreshSection(sectionId) {
		const section = document.getElementById(sectionId);
		section.innerHTML = ''; // Clear the content
		applyFilters();
	}

	// Attach event listeners to filter buttons
	const serviceButton = document.getElementById('service-button');
	if (serviceButton) {
		serviceButton.addEventListener('click', function (e) {
			e.preventDefault();
			applyFilters();
		});
	}

	const platformButton = document.getElementById('platform-button');
	if (platformButton) {
		platformButton.addEventListener('click', function (e) {
			e.preventDefault();
			applyFilters();
		});
	}

	const industryButton = document.getElementById('industry-button');
	if (industryButton) {
		industryButton.addEventListener('click', function (e) {
			e.preventDefault();
			applyFilters();
		});
	}
	const loadMoreButton = document.getElementById('loadmore-button-truestory');
	if (loadMoreButton) {
		loadMoreButton.addEventListener('click', function (e) {
			e.preventDefault();
			const industryValue = document.getElementById('industryid').value;//eslint-disable-line
			const platformValue = document.getElementById('platformid').value;//eslint-disable-line
			const serviceValue = document.getElementById('serviceid').value;//eslint-disable-line
			loadMorePosts(platformValue, serviceValue, industryValue);
		});
	}
});
